import CitySEOHead from "@/components/feature/CitySEOHead";
import WinterParkHeroSection from "./components/HeroSection";
import WinterParkStickyNav from "./components/StickyNav";
import WinterParkProcessingTimeSection from "./components/ProcessingTimeSection";
import WinterParkServicesSection from "./components/ServicesSection";
import WinterParkLocalAreaSection from "./components/LocalAreaSection";
import WinterParkTravelTimingSection from "./components/TravelTimingSection";
import WinterParkDestinationsSection from "./components/DestinationsSection";
import WinterParkTestimonialsSection from "./components/TestimonialsSection";
import WinterParkAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WinterParkComparisonSection from "./components/ComparisonSection";
import WinterParkMistakesSection from "./components/MistakesSection";
import WinterParkHowItWorksSection from "./components/HowItWorksSection";
import WinterParkFAQSection, { faqs } from "./components/FAQSection";
import WinterParkHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WinterParkFinalCTA from "./components/FinalCTA";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function WinterParkPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Winter Park"
        state="Florida"
        stateAbbr="FL"
        route="/cities/winter-park"
        title="Emergency Passport Winter Park, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Winter Park, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Rollins College students, Park Avenue professionals, and Orange County families."
        geoPlacename="Winter Park, Florida"
        geoPosition="28.5999;-81.3392"
        faqs={faqs}
        servicesSchema={servicesSchema}
      />
      <WinterParkHeroSection />
      <WinterParkStickyNav />
      <WinterParkProcessingTimeSection />
      <WinterParkServicesSection />
      <WinterParkLocalAreaSection />
      <WinterParkTravelTimingSection />
      <WinterParkDestinationsSection />
      <WinterParkTestimonialsSection />
      <WinterParkAcceptanceFacilitiesSection />
      <WinterParkComparisonSection />
      <WinterParkMistakesSection />
      <WinterParkHowItWorksSection />
      <WinterParkFAQSection />
      <WinterParkHelpfulResourcesSection />
      <WinterParkFinalCTA />
    </div>
  );
}